import React from 'react';
import './style.scss';

const TextInput = ({ handleChange, label, value, name, type, error }) => (
    (
        <div className='form-group'>
            <label htmlFor={name}>{label}</label>
            <input name={name} value={value} type={type} onChange={e => {
                e.preventDefault();
                handleChange(e.target);
            }} />
            {error &&
                <div className="err">Required input please complete!</div>
            }
        </div>
    )
);

export default TextInput;